var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { optInFeatureFlag } from '@/clients/reborn';
import { ATLAS_V4_FLAG } from '@/shared/utils/helpers';
import { mixpanelTracking } from '@/services/mixpanel';
/** ID do vídeo de apresentação da nova versão (https://youtu.be/Sa-aFcyhPrc). */
const V4_INTRO_YOUTUBE_ID = 'Sa-aFcyhPrc';
/**
 * Modal de migração para a nova versão (V4) — exibido nas telas antigas para
 * as contas convidadas (`atlas_v4_convite`) que ainda não têm a flag
 * `atlas_v4`. É bloqueante: a única saída é "Utilizar agora", que ativa a flag
 * via opt-in self-service (API do reborn) e recarrega a página já na nova
 * experiência.
 */
let V4IntroModal = class V4IntroModal extends Vue {
    constructor() {
        super(...arguments);
        this.open = true;
        this.loading = false;
        this.error = '';
    }
    get youtubeEmbedUrl() {
        return `https://www.youtube.com/embed/${V4_INTRO_YOUTUBE_ID}`;
    }
    mounted() {
        mixpanelTracking('V4: viu o modal de introdução da nova versão');
    }
    async optIn() {
        this.loading = true;
        this.error = '';
        try {
            await optInFeatureFlag(ATLAS_V4_FLAG);
            mixpanelTracking('V4: ativou a nova versão (opt-in)');
            // Recarrega para o auth rebuscar o user (features atualizadas) e o
            // switcher da busca servir a nova experiência.
            window.location.reload();
        }
        catch (e) {
            this.loading = false;
            this.error =
                'Não foi possível ativar a nova versão agora. Tente novamente em ' +
                    'instantes ou fale com o nosso suporte.';
        }
    }
};
V4IntroModal = __decorate([
    Component({ name: 'V4IntroModal' })
], V4IntroModal);
export default V4IntroModal;
